makeErrorEnum = require 'lib/make-error-enum'
Plugin = require 'models/plugin'
PluginHandlers = require 'views/internal/plugins/plugin-handlers'
PluginIO = require 'views/internal/plugins/plugin-io'

PluginIOCacheError = makeErrorEnum 'PluginCache', [
  'InvalidArgument'
]

class PluginIOCache
  Error: PluginIOCacheError

  constructor: ->
    @pluginFromId = {}

  get: (plugin) ->
    if plugin !instanceof Plugin
      throw PluginIOCacheError.InvalidArgument("expected a plugin")

    id = plugin.id
    if (existingPlugin = @fromId(id))?
      return existingPlugin

    iframeConnectorUrl = plugin.get('iframeConnectorUrl')

    ownedByTrello = plugin.get('idOrganizationOwner') == window.firstPartyPluginsOrg
    isOnTrelloDomain = /^https:\/\/[\w-]+\.(?:staging\.)?trello\.services\//.test(iframeConnectorUrl)
    isOnLocalhost = /^http:\/\/localhost:\d+\/[\w-]+\//.test(iframeConnectorUrl) && /^http:\/\/localhost:\d+\//.test(window.location.href)

    canUseRestrictedHandlers = ownedByTrello && (isOnTrelloDomain || isOnLocalhost)

    io = new PluginIO(
      plugin,
      PluginHandlers({
        idPlugin: id,
        allowRestricted: canUseRestrictedHandlers
      })
    )

    @pluginFromId[id] = io
    io

  fromId: (id) ->
    @pluginFromId[id]

  drop: (idPlugin) ->
    if (plugin = @pluginFromId[idPlugin])?
      delete @pluginFromId[idPlugin]
      plugin.drop()

module.exports = new PluginIOCache()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-io-cache.coffee